import { render } from "./LinkBox.vue?vue&type=template&id=7883e6b8&scoped=true"
import script from "./LinkBox.vue?vue&type=script&lang=js"
export * from "./LinkBox.vue?vue&type=script&lang=js"

import "./LinkBox.vue?vue&type=style&index=0&id=7883e6b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7883e6b8"]])

export default __exports__